var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "是否斜体" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small" },
              model: {
                value: _vm.italic,
                callback: function($$v) {
                  _vm.italic = $$v
                },
                expression: "italic"
              }
            },
            _vm._l(_vm.italicConfigList(_vm.value.type), function(item, index) {
              return _c(
                "el-radio-button",
                { key: index, attrs: { label: item.label } },
                [_vm._v(_vm._s(item.value))]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a94d32f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a94d32f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/render_setting/RenderItalic.vue
// module id = null
// module chunks = 